import { Button, Heading, Text } from '@apollo/orbit';
import { Rocket2 } from '@apollo/space-kit/illustrations/Rocket2';
import React, { useCallback, useState } from 'react';

import { ContactSupportLink } from 'src/components/ContactSupportCTAs';
import { ViewSchemaModal } from 'src/components/viewSchemaModal/ViewSchemaModal';

interface Props {
  supergraphSdl?: string | null;
  graphId: string;
}

export const EmptyBuildErrors = ({ supergraphSdl, graphId }: Props) => {
  const [sdlPageLayoutModalVisible, setSDLPageLayoutModalVisible] =
    useState(false);
  const onSDLPageLayoutModalClose = useCallback(() => {
    setSDLPageLayoutModalVisible(false);
  }, [setSDLPageLayoutModalVisible]);

  return (
    <div className="flex flex-1 items-center justify-center">
      <div className="flex flex-1 flex-col items-center justify-center space-y-3 px-6">
        <Rocket2 className="w-[180px]" />
        {supergraphSdl === null ? (
          // Even though there are no build errors, the supergraph SDL is not returned,
          // meaning that the build failed.
          <>
            <Heading as="h1" size="xl">
              Build was not successful.
            </Heading>
            <Text variant="subtitle" className="max-w-2xl text-center">
              The build failed for an unexpected reason. If this problem
              continues, please contact{' '}
              <ContactSupportLink>Apollo Support</ContactSupportLink>.
            </Text>
          </>
        ) : (
          <>
            <Heading as="h1" size="xl">
              Build was successful!
            </Heading>
            <Text variant="subtitle" className="max-w-2xl text-center">
              No errors found. You can now view the <b>supergraph schema</b>{' '}
              that resulted from your check.
            </Text>
            <div className="text-center">
              <Button
                variant="secondary"
                onClick={() => setSDLPageLayoutModalVisible(true)}
              >
                View supergraph schema
              </Button>
            </div>
          </>
        )}
      </div>
      {sdlPageLayoutModalVisible && supergraphSdl && (
        <ViewSchemaModal
          isOpen
          graphId={graphId}
          sdl={supergraphSdl}
          onClose={onSDLPageLayoutModalClose}
          isCsdl={true}
        />
      )}
    </div>
  );
};
